import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './views/Home';
import Normalize from './views/Normalize';
import Names from './views/masters/Names';
import ComunidadesAutonomasView from './ComunidadesAutonomas/ComunidadesAutonomasView';
import ProvinciasView from './Provincias/ProvinciasView';
import MunicipiosView from './Municipios/MunicipiosView';
import TipoViasView from './TiposVia/TiposViaView';
import TipoViaVariacionesView from './TiposViaVariaciones/TipoViaVariacionesView';
import TrameroView from './Tramero/TrameroView';
import NombresPilaView from './NombresPila/NombresPilaView';
import NombrePilaVariacionesView from './NombresPilaVariaciones/NombrePilaVariacionesView';
import ApellidosView from './Apellidos/ApellidosView';
import ApellidoVariacionesView from './ApellidosVariaciones/ApellidosVariacionView';
import DetalleNormalizacion from './Normalizacion/DetalleNormalizacion';
import MunicipiosVariacionesView from './MunicipiosVariaciones/MunicipiosVariacionesView';
import ConsolidateProgress from './Consolidaciones/ConsolidateProgress';
import DataSummary from './Data/DataSummary';
import DetalleConsolidacion from './Consolidaciones/DetalleConsolidacion';
import ProvinciasSummaryView from './Summary/Provincias/ProvinciasSummaryView';
import DataView from './Data/DataView';
import Login from './views/Login';
import SettingsHome from './Settings/SettingsHome';
import UserView from './Settings/Users/UserView';
import IpsHome from './Settings/IPS/IpsHome';
import IpsCodigosPostales from './Settings/IPS/IpsCodigosPostales';
import ComunidadesAutonomasDetail from './Chart/ComunidadesAutonomas/ComunidadesAutonomasDetail';
import ProvinciaDetail from './Chart/Provincias/ProvinciaDetail';
import IpsProgress from './Settings/IPS/IpsProgress';
import IpsData from './Settings/IPS/IpsData';
import Notificaciones from './Notificaciones/Notificaciones';
import ClientesView from './Clientes/ClientesView';
import Extracciones from './Extracciones/Extracciones';
import DetalleExtraccion from './Extracciones/DetalleExtraccion';
import UserProfile from './Settings/Users/UserProfile';
import NivelesPermisos from './Settings/Permisos/NivelesPermisos';
import Permisos from './Settings/Permisos/Permisos';
import LogView from './Settings/Log/LogView';
import BusquedaExtracciones from './Extracciones/BusquedaExtracciones';
import VerticalesView from './Verticales/VerticalesView';
import NewExtraccion from './Extracciones/NewExtraccion';
import TimerJobs from './Settings/TimerJobs/TimerJobs';
import TimerJobHistory from './Settings/TimerJobs/TimerJobHistory';
import TimerJobHistoryDetail from './Settings/TimerJobs/TimerJobHistoryDetail';


const adTheme = createTheme({
  palette: {
    primary: {
      main: '#376996',
      contrastText: '#fff'
    },
    secondary: {
      main: '#a62639',
      contrastText: '#fff'
    }
  },
});

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={adTheme}>
        <BrowserRouter>
            <Routes>
              <Route path="/" element={<DataSummary />}/>
              <Route path="/login" element={<Login />}/>
              <Route path="/normalizaciones" element={<Home />}/>
              <Route path="/new" element={<Normalize />} />
              <Route path="/masters/names" element={<Names />} />
              <Route path="/masters/comunidadesautonomas" element={<ComunidadesAutonomasView />} />
              <Route path="/masters/provincias" element={<ProvinciasView />} />
              <Route path="/masters/municipios" element={<MunicipiosView />} />
              <Route path="/masters/municipiosvariaciones" element={<MunicipiosVariacionesView />} />
              <Route path="/masters/tiposvia" element={<TipoViasView />} />
              <Route path="/masters/tipoviavariaciones" element={<TipoViaVariacionesView />} />
              <Route path="/masters/tramero" element={<TrameroView />} />
              <Route path="/masters/nombresdepila" element={<NombresPilaView />} />
              <Route path="/masters/variacionesnombresdepila" element={<NombrePilaVariacionesView />} />
              <Route path="/masters/apellidos" element={<ApellidosView />} />
              <Route path="/masters/variacionesapellidos" element={<ApellidoVariacionesView />} />
              <Route path="/normalizacion" element={<DetalleNormalizacion />} />
              <Route path="/consolidaciones" element={<ConsolidateProgress />} />
              <Route path="/consolidacion" element={<DetalleConsolidacion />} />
              <Route path="/data" element={<DataView />} />
              <Route path="/settings" element={<SettingsHome />} />
              <Route path="/settings/users" element={<UserView />} />
              <Route path="/settings/ips" element={<IpsHome />} />
              <Route path="/settings/ips/codigospostales" element={<IpsCodigosPostales />} />
              <Route path="/settings/ips/progress" element={<IpsProgress />} />
              <Route path="/settings/ips/data" element={<IpsData />} />
              <Route path="/settings/nivelespermisos" element={<NivelesPermisos />} />
              <Route path="/settings/permisos" element={<Permisos />} />
              <Route path="/settings/log" element={<LogView />} />
              <Route path="/settings/jobs" element={<TimerJobs />} />
              <Route path="/settings/job/history" element={<TimerJobHistory />} />
              <Route path="/settings/job/history/detail" element={<TimerJobHistoryDetail />} />
              <Route path="/summary/comunidadesautonomas" element={<ComunidadesAutonomasDetail />} />
              <Route path="/summary/provincia" element={<ProvinciaDetail />} />
              <Route path="/notificaciones" element={<Notificaciones />} />
              <Route path="/clientes" element={<ClientesView />} />
              <Route path="/verticales" element={<VerticalesView />} />
              <Route path="/extracciones" element={<Extracciones />} />
              <Route path="/extracciones/detalle" element={<DetalleExtraccion />} />
              <Route path="/extracciones/busqueda" element={<BusquedaExtracciones />} />
              <Route path="/extracciones/nueva" element={<NewExtraccion />} />
              <Route path="/perfil" element={<UserProfile />} />
            </Routes>
          </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
